import React from "react";
import type { Theme } from "./ProcessTheme";

const ThemeContext = React.createContext<Theme | null>(null);

export default ThemeContext;
